import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { formatDateTime } from "../lib/format";
import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { ScrollText } from "lucide-react";

const ACTION_STYLE = {
  create: "bg-emerald-100 text-emerald-700",
  update: "bg-amber-100 text-amber-700",
  soft_delete: "bg-rose-100 text-rose-700",
  delete: "bg-rose-100 text-rose-700",
  copy_previous: "bg-blue-100 text-blue-700",
  change_password: "bg-gtsnavy/10 text-gtsnavy",
};

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit-logs").then((r) => setLogs(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-5" data-testid="audit-page">
      <div>
        <h2 className="font-nunito font-extrabold text-2xl text-gtsnavy">Audit Log</h2>
        <p className="text-sm text-muted-foreground">Riwayat perubahan data</p>
      </div>
      <Card className="rounded-2xl border-none shadow-[0_8px_30px_rgb(16,42,86,0.06)] bg-white overflow-hidden">
        <div className="overflow-x-auto gts-scroll">
          <table className="w-full text-sm">
            <thead><tr className="bg-gtsnavy text-white">
              <th className="text-left px-4 py-3">Waktu</th>
              <th className="text-left px-4 py-3">Pengguna</th>
              <th className="text-left px-4 py-3">Aksi</th>
              <th className="text-left px-4 py-3">Entitas</th>
            </tr></thead>
            <tbody>
              {logs.length === 0 && <tr><td colSpan={4} className="text-center py-10 text-muted-foreground">Belum ada log.</td></tr>}
              {logs.map((l, i) => (
                <tr key={i} className={i % 2 ? "bg-orange-50/30" : ""} data-testid={`audit-row-${i}`}>
                  <td className="px-4 py-2.5 whitespace-nowrap text-xs">{formatDateTime(l.timestamp)}</td>
                  <td className="px-4 py-2.5 font-medium text-gtsnavy">{l.user_name}</td>
                  <td className="px-4 py-2.5"><Badge className={`rounded-full ${ACTION_STYLE[l.action] || "bg-gray-100 text-gray-600"}`}>{l.action}</Badge></td>
                  <td className="px-4 py-2.5 text-muted-foreground">{l.entity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
